// 核销案件池 
var CaseVerify = function () { return import('~/pages/case-verify-manage/case-verify.vue'); };
export default [
    {
        path: '/case-verify-manage/case-verify',
        name: 'case-verify',
        title: '核销案件',
        component: CaseVerify
    }
];
